import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-fluid formgrid grid" }
const _hoisted_2 = { class: "field col-12 lg:col-7" }
const _hoisted_3 = { class: "field col-12 lg:col-3" }
const _hoisted_4 = { class: "field col-12 lg:col-2 text-right" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { style: {"display":"block"} }, " ", -1)
const _hoisted_6 = {
  key: 0,
  class: "col-12"
}
const _hoisted_7 = {
  key: 1,
  class: "col-12"
}
const _hoisted_8 = { class: "grid" }
const _hoisted_9 = { class: "col-12 mt-6" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "col-12 mt-6" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "col-12 mt-6" }
const _hoisted_15 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Chart = _resolveComponent("Chart")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.handleSubmit()), ["prevent"])),
    onKeydown: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleKeydown($event)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("statStockChart.company")), 1),
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.companyId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyId) = $event)),
          options: _ctx.companies,
          onChange: _ctx.dataChanged,
          optionLabel: "name",
          optionValue: "id",
          placeholder: "-"
        }, null, 8, ["modelValue", "options", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", null, _toDisplayString(_ctx.t("statStockChart.month")), 1),
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.monthDate,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.monthDate) = $event)),
          options: _ctx.months,
          onChange: _ctx.dataChanged,
          optionLabel: "label",
          optionValue: "date",
          placeholder: "-"
        }, null, 8, ["modelValue", "options", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_Button, {
          label: _ctx.t('buttons.search'),
          icon: "pi pi-search",
          type: "submit",
          class: "p-button-primary p-uppercase"
        }, null, 8, ["label"])
      ]),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_Divider)
          ]))
        : _createCommentVNode("", true),
      (_ctx.showResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h5", _hoisted_10, _toDisplayString(_ctx.t("statStockChart.chartMonthlyStock")) + " - " + _toDisplayString(_ctx.FormatHelpers.capitalizeFirstLetter(_ctx.d(_ctx.monthDate, "longMonth"))), 1),
                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.t("statStockChart.stockPeakValueLabel")) + ": " + _toDisplayString(_ctx.n(_ctx.monthlyStockPeakValue, "number0")), 1),
                _createVNode(_component_Chart, {
                  type: "bar",
                  data: _ctx.chartMonthlyStock,
                  options: _ctx.ChartHelpers.getChartOptionsLandscape()
                }, null, 8, ["data", "options"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("h5", _hoisted_13, _toDisplayString(_ctx.t("statStockChart.chartMonthlyStockByDetail")) + " - " + _toDisplayString(_ctx.FormatHelpers.capitalizeFirstLetter(_ctx.d(_ctx.monthDate, "longMonth"))), 1),
                _createVNode(_component_Chart, {
                  type: "bar",
                  data: _ctx.chartMonthlyStockByDetail,
                  options: _ctx.ChartHelpers.getChartOptionsLandscape()
                }, null, 8, ["data", "options"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("h5", _hoisted_15, _toDisplayString(_ctx.t("statStockChart.chartMonthlyStockByType")) + " - " + _toDisplayString(_ctx.FormatHelpers.capitalizeFirstLetter(_ctx.d(_ctx.monthDate, "longMonth"))), 1),
                _createVNode(_component_Chart, {
                  type: "bar",
                  data: _ctx.chartMonthlyStockByType,
                  options: _ctx.ChartHelpers.getChartOptionsLandscape()
                }, null, 8, ["data", "options"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 32))
}